import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react'
import { inject, observer } from 'mobx-react';
import { Drawer, Grid, AppBar, Toolbar, IconButton, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody, Fab, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button } from '@material-ui/core';
import NavigationDrawerItems from './NavigationDrawerItems';
import { observable, action } from 'mobx';
import MenuIcon from '@material-ui/icons/Menu';
import ReportStore from 'src/stores/ReportStore';
import moment from 'moment';
import {MuiPickersUtilsProvider, DatePicker, Day} from "material-ui-pickers"
import MomentUtils from '@date-io/moment';
import 'moment/locale/cs';
import { MealToMakeReport } from 'src/models/reports/MealToMakeReport';
import CiselnikyStore from 'src/stores/CiselnikyStore';
import { isNull, isUndefined } from 'util';

export interface IMealsToMakeReportProps extends RouteComponentProps<any> {
    reportStore?: ReportStore;
    ciselnikyStore?: CiselnikyStore;
}

@inject('reportStore')
@inject('ciselnikyStore')
@observer
class MealsToMakeReport extends React.Component<IMealsToMakeReportProps>{

    constructor(props: Readonly<IMealsToMakeReportProps>) {
        super(props);
        props.reportStore.loadMealsToMakeReport(new Date()).then(retVal => {this.handleReportLoaded(retVal)});
    }

    @observable private reportLoaded: boolean = false;
    @observable private isDrawerOpened: boolean = false;
    private mealsReportDate: Date = new Date();
    private mealsToMakeByProgram: any[] = [];

    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    @action
    private handleReportDateChange = date => {
        this.mealsReportDate = moment(date).toDate();
        this.reportLoaded = false;
        this.props.reportStore.loadMealsToMakeReport(this.mealsReportDate).then(retVal => {this.handleReportLoaded(retVal)});
    }

    @action
    private handleReportLoaded = (success: boolean) => {
        this.props.ciselnikyStore.getAllValidPrograms().forEach(prg => {
            this.mealsToMakeByProgram[prg.id] = {
                program: prg.value,
                countSnidane: 0,
                countSvacina1: 0,
                countObed: 0,
                countSvacina2: 0,
                countVecere: 0,
                countSnidaneEKO: 0,
                countSvacina1EKO: 0,
                countObedEKO: 0,
                countSvacina2EKO: 0,
                countVecereEKO: 0,
                valid: false 
            };
        });
        this.props.reportStore.report.forEach(item => {
            if(item.denTyp !== 'odhlaseny') {
                let program: string = item.turnusProgram;
                let menuParts: string[] = item.rozsah.split(",");
                if(item.denTyp === 'zmena' && item.denProgram != null) {
                    program = item.denProgram;
                    menuParts = item.denRozsah.split(",");
                }
                this.mealsToMakeByProgram[program].valid = true;
                if(menuParts.indexOf("plny") !== -1) {
                    this.mealsToMakeByProgram[program].countSnidane += 1;
                    this.mealsToMakeByProgram[program].countSvacina1 += 1;
                    this.mealsToMakeByProgram[program].countObed += 1;
                    this.mealsToMakeByProgram[program].countSvacina2 += 1;
                    this.mealsToMakeByProgram[program].countVecere += 1;
                    if(item.eko) {
                        this.mealsToMakeByProgram[program].countSnidaneEKO += 1;
                        this.mealsToMakeByProgram[program].countSvacina1EKO += 1;
                        this.mealsToMakeByProgram[program].countObedEKO += 1;
                        this.mealsToMakeByProgram[program].countSvacina2EKO += 1;
                        this.mealsToMakeByProgram[program].countVecereEKO += 1;
                    }
                } else {
                    if(menuParts.indexOf("snidane") !== -1) {
                        this.mealsToMakeByProgram[program].countSnidane += 1;
                        if(item.eko) {this.mealsToMakeByProgram[program].countSnidaneEKO += 1;}
                    }
                    if(menuParts.indexOf("svacina1") !== -1) {
                        this.mealsToMakeByProgram[program].countSvacina1 += 1;
                        if(item.eko) {this.mealsToMakeByProgram[program].countSvacina1EKO += 1;}
                    }
                    if(menuParts.indexOf("obed") !== -1) {
                        this.mealsToMakeByProgram[program].countObed += 1;
                        if(item.eko) {this.mealsToMakeByProgram[program].countObedEKO += 1;}
                    }
                    if(menuParts.indexOf("svacina2") !== -1) {
                        this.mealsToMakeByProgram[program].countSvacina2 += 1;
                        if(item.eko) {this.mealsToMakeByProgram[program].countSvacina2EKO += 1;}
                    }
                    if(menuParts.indexOf("vecere") !== -1) {
                        this.mealsToMakeByProgram[program].countVecere += 1;
                        if(item.eko) {this.mealsToMakeByProgram[program].countVecereEKO += 1;}
                    }
                }
            }            
        });
        this.reportLoaded = success;
    }

    private getLabelForDayType(denTyp: string) {
        if(denTyp === null) {
            return "Žádná";
        }
        switch(denTyp) {
            case "odhlaseny": return "Odhlášený den";
            case "nahrada": return "Nahrazený den";
            default: return "";
        }
    }

    private getLabelForDayProgram(denProgram: string) {
        if(denProgram === null || denProgram === 'none')  {
            return "Žádný";
        } else {
            return denProgram + " kJ";
        }
    }

    private getLabelForTurnusProgram(program: number) {
        if(isNull(program) || isUndefined(program)) {
            return "Žádný";
        } else {
            return this.props.ciselnikyStore.getProgramByID(program).value + "kJ";
        }
    }

    private getLabelForTurnusDate(turnusId:number, turnusOd: Date, turnusDo: Date) {
        if(turnusId === null) {
            return "Žádný";
        }
        return turnusOd.toLocaleDateString() + " - " + turnusDo.toLocaleDateString();
    }

    public render() {
        return (
            <div>
                <MuiPickersUtilsProvider utils={MomentUtils} locale='cs'>
                <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                    <NavigationDrawerItems />
                </Drawer>
                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        <AppBar position="static" >
                            <Toolbar>
                                <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                    <MenuIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit" >
                                    Plánovaná jídla
                            </Typography>
                            </Toolbar>
                        </AppBar>
                    </Grid>
                    <Grid item xs={12} style={{ margin: 8 }}>
                        <Paper>
                            <Grid container spacing={8}>
                                <Grid item xs={12} style={{ margin: 8 }}>
                                    <DatePicker label="Datum reportu" value={this.mealsReportDate} onChange={this.handleReportDateChange} />
                                    <Button href={this.props.reportStore.getMealsToMakeXlsxUrl(this.mealsReportDate)}>XLSX</Button>
                                </Grid>
                                    {this.reportLoaded ? 
                                    <Grid item xs={12} style={{ margin: 8 }}>
                                        <Grid item xs={9} style={{ margin: 8 }}>
                                            <Typography variant="h6" color="inherit" >Jídla dle programu:</Typography>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Program</TableCell>
                                                        <TableCell>Snídaně</TableCell>
                                                        <TableCell>1.&nbsp;svačina</TableCell>
                                                        <TableCell>Oběd</TableCell>
                                                        <TableCell>2.&nbsp;svačina</TableCell>
                                                        <TableCell>Večeře</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                {this.mealsToMakeByProgram.filter(item => item.valid === true).map(item => (
                                                    <TableRow>
                                                        <TableCell>{item.program} kJ</TableCell>
                                                        <TableCell>{item.countSnidane}{item.countSnidaneEKO > 0 ? " (" + item.countSnidaneEKO + " EKO)" : ""}</TableCell>
                                                        <TableCell>{item.countSvacina1}{item.countSvacina1EKO > 0 ? " (" + item.countSvacina1EKO + " EKO)" : ""}</TableCell>
                                                        <TableCell>{item.countObed}{item.countObedEKO > 0 ? " (" + item.countObedEKO + " EKO)" : ""}</TableCell>
                                                        <TableCell>{item.countSvacina2}{item.countSvacina2EKO > 0 ? " (" + item.countSvacina2EKO + " EKO)" : ""}</TableCell>
                                                        <TableCell>{item.countVecere}{item.countVecereEKO > 0 ? " (" + item.countVecereEKO + " EKO)" : ""}</TableCell>
                                                    </TableRow>
                                                ))}
                                                </TableBody>
                                            </Table>
                                        </Grid>
                                        <Grid item xs={12} style={{ margin: 8 }}>
                                            <Typography variant="h6" color="inherit" >Klienti pro tento den:</Typography>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Klient</TableCell>
                                                        <TableCell>Turnus</TableCell>
                                                        <TableCell>Program</TableCell>
                                                        <TableCell>Změna</TableCell>
                                                        <TableCell>Náhradní program</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        this.props.reportStore.report.map(reportRecord => (
                                                            <TableRow hover key={reportRecord.klientId + "-" + reportRecord.turnusId}>
                                                                <TableCell>{reportRecord.jmeno} {reportRecord.prijmeni}</TableCell>
                                                                <TableCell>{this.getLabelForTurnusDate(reportRecord.turnusId, reportRecord.od, reportRecord.do)}</TableCell>
                                                                <TableCell>{this.getLabelForTurnusProgram(reportRecord.turnusProgram)}</TableCell>
                                                                <TableCell>{this.getLabelForDayType(reportRecord.denTyp)}</TableCell>
                                                                <TableCell>{this.getLabelForDayProgram(reportRecord.denProgram)}</TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </Grid> 
                                    </Grid>: <div>Žádný report nebyl načten</div>}
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
                </MuiPickersUtilsProvider>
            </div>
        );
    }
}

export default withRouter(MealsToMakeReport);


// WEBPACK FOOTER //
// ./src/components/MealsToMakeReport.tsx